import moment from "moment-timezone";
import {FORMATS} from "../core/formats";
import {CoreUtils} from "../core";

export const OrderUtils = {

  getOrderManagementStatus(o: OrderSchema, tz: string): OrderStatusManagement {

    if (o.status !== "confirmed") {
      return o.status;
    }

    const due = this.dueInMillis(o, tz);
    if (due < CoreUtils.dates.getMillisFromMinutes(120)) {
      return "due_soon";
    }

    return "upcoming";

  },

  dueInMillis(o: OrderSchema, tz: string) {

    if (o.ready_in && o.ready_in.timestamp) {
      return o.ready_in.timestamp - Date.now();
    }

    if (o.config.due === "later") {

      if (o.config.timestamp) {
        return o.config.timestamp - Date.now();
      }

      const dueMilli = moment.tz(`${o.config.date} ${o.config.time}`, FORMATS.moment.datetime, tz).valueOf();

      return dueMilli - Date.now();

    }

    return 0;

  },

  icon(service: OrderServices): string {
    switch (service) {
      case "pickup":
        return "shopping-bag";
      case "delivery":
        return "motorcycle";
      case "dine_in":
        return "utensils";
      case "table_booking":
        return "calendar-alt";
      default:
        return "shopping-bag";
    }
  },

  sortByDue(tz: string) {
    return (a: OrderSchema, b: OrderSchema) => {
      console.log("dueSort");
      const dueA = this.dueInMillis(a, tz);
      const dueB = this.dueInMillis(b, tz);
      if (dueA < dueB) {
        return -1;
      }
      else if (dueA > dueB) {
        return 1;
      }
      return 0;
    };
  },

  sortByCreated(a: OrderSchema, b: OrderSchema) { // BIGGER VALUES LAST
    console.log("createdSort");
    if (a.created < b.created) {
      return -1;
    }
    else if (a.created > b.created) {
      return 1;
    }
    return 0;
  },

  sortByUpdated(a: OrderSchema, b: OrderSchema) { // BIGGER VALUES FIRST
    console.log("updatedSort");
    if (a.updated && b.updated) {
      if (a.updated > b.updated) {
        return -1;
      }
      else if (a.updated < b.updated) {
        return 1;
      }
      return 0;
    }
    return this.sortByCreated(a, b);
  },

  sortFunctionByStatus(s: OrderStatusManagement, tz: string) {
    if (["unconfirmed"].indexOf(s) !== -1) {
      return this.sortByCreated;
    }
    else if (["complete", "cancelled"].indexOf(s) !== -1) {
      return this.sortByUpdated;
    }
    return this.sortByDue(tz);
  },

  checkBlockedAddresses(destination: string, block?: string[]): boolean {
    block = block || [];
    if (block.length > 0) {
      for (const a of block) {
        if (a !== "") {
          if (destination.toLowerCase().indexOf(a.toLowerCase()) !== -1) {
            return true;
          }
        }
      }
    }
    return false;
  },

};
